"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PaymentManual = require("../../PaymentManual/PaymentManual");
var _payment = require("../../assets/icons/payment");
var _excluded = ["cards"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var bankIds = ['Bog', 'Tbc', 'Lib'];
var _default = function _default(_ref) {
  var cards = _ref.cards,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, bankIds.map(function (key) {
    return /*#__PURE__*/_react.default.createElement(_PaymentManual.PaymentManual, _extends({
      key: key,
      type: 'card',
      cardOptions: cards.filter(function (card) {
        return card.bank === key;
      }),
      eventKey: key,
      logo: _payment.BankLogos[key],
      style: {
        margin: '1rem 0'
      }
    }, props));
  }), /*#__PURE__*/_react.default.createElement(_PaymentManual.PaymentManual, _extends({
    type: 'card',
    cardOptions: cards,
    eventKey: 'Any',
    logo: _payment.BankLogos['Any'],
    style: {
      margin: '1rem 0'
    }
  }, props)));
};
exports.default = _default;